<template>
  <div class="Exhibition">
    <detailsTop :topIndex="topIndex" @bannerIndexClick="bannerIndexClick" />
    <div class="news-content">
      <div class="new-center">
        <bannerTips
          :bannerTipsList="bannerTipsList"
          @changeTips="changeTips"
          :bannerIndex="bannerIndex"
        />
        <div class="exhibition-wrap">
          <!-- <div class="product" v-show="bannerIndex == 0">
            <div class="product-right">
              分类:考虑到不知道产品数量，是否做分页，是否需要做联动，暂未写分类列表
          
            </div>
            <div class="product-left">
              <div
                class="product-item"
                v-for="(item, index) in newList"
                :key="index"
                @click="exhibitionItem(item)"
              >
                <el-image class="product-img" lazy :src="baseURL + item.cover">
                  <div slot="placeholder" class="image-slot">
                    加载中<span class="dot">...</span>
                  </div>
                </el-image>
                <div class="product-title">{{ item.title }}</div>
              </div>
            </div>
          </div> -->

          <div
            v-show="bannerIndex == 0"
            class="exhibition-item"
            @click="exhibitionItem(item)"
            v-for="(item, index) in newList"
            :key="index"
          >
            <el-image class="exhibition-img" lazy :src="baseURL + item.cover">
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <div class="exhibition-title">{{ item.title }}</div>
          </div>

          <div class="exhibition-table" v-show="bannerIndex == 1">
            <el-table
              :data="purchaseList"
              table-layout="auto"
              height="600"
              style="width: 100%; cursor: pointer"
              :header-cell-style="{ 'text-align': 'center' }"
              @row-click="handleSeleUserId"
            >
              <el-table-column prop="projectName" label="项目名称" width="600">
              </el-table-column>
              <el-table-column prop="projectNo" label="招标号" align="center">
              </el-table-column>
              <el-table-column
                prop="projectCompany"
                label="招标单位"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="发布时间"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- <div class="pagination" v-show="bannerIndex != 2">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            prev-text="上一页"
            next-text="下一页"
            :current-page.sync="page"
            :page-size="size"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div> -->
      </div>
    </div>

    <pageBottom />
  </div>
</template>

<script>
import detailsTop from "@/components/detailsTop.vue";
import pageBottom from "@/components/pageBottom";
import bannerTips from "@/components/bannerTips";
import { selectTNewsPage, getpurchase } from "@/api/api.js";

export default {
  name: "news",
  components: {
    detailsTop,
    pageBottom,
    bannerTips,
  },
  data() {
    return {
      bannerTipsList: [],
      topIndex: null,
      bannerIndex: 0,
      page: 1,
      size: 9,
      total: null,
      newList: [],
      purchaseList: [],
    };
  },
  created() {
    this.topIndex = this.$route.query.topIndex;
    this.bannerTipsList = JSON.parse(localStorage.getItem("bannerList"));
    this.bannerIndex = Number(localStorage.getItem("lobannerIndex"));
    this.getData();
    this.getpurchaseList();
  },
  mounted() {
    const that = this;
    window.addEventListener("setItemEvent", function (e) {
      if (e.key === "lobannerIndex") {
        // myKey是需要监听的键名
        that.lobannerIndex = e.newValue;
        that.bannerIndex = e.newValue;
        that.getData();
      }
    });
  },
  methods: {
    bannerIndexClick(index) {
      // this.bannerIndex = index;
    },
    changeTips(index) {
      this.bannerIndex = index;
      this.getData();
    },
    async getData() {
      var params = {
        page: this.page,
        size: this.size,
        projectTypeParentId: this.bannerTipsList[this.bannerIndex]?.parentId,
        projectTypeSubId: this.bannerTipsList[this.bannerIndex]?.projectTypeId,
      };
      const { data } = await selectTNewsPage(params);
      if (data.code === 200) {
        this.newList = data.data.list;
        this.total = data.data.total;
      }
    },
    exhibitionItem(item) {
      // this.$router.push({ name: 'exhibitionDetails' })
      const routeUrl = this.$router.resolve({
        path: "/exhibitionDetails",
        query: {
          bannerIndex: this.bannerIndex,
          exhibitionCenterId: item.exhibitionCenterId,
          projectTypeParentId: item.projectTypeParentId,
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },

    // 获取招投标
    async getpurchaseList() {
      const { data } = await getpurchase({ pageNum: 0, pageSize: 20 });
      this.purchaseList = data.rows;
    },
    handleSeleUserId(row) {
      let purchaseUrl =
        "http://wsjtoa.com:8098/purchase/project/purchase/view/";
      window.open(purchaseUrl + row.id);
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  width: 86%;
  max-width: 1440px;
  margin: 20px auto;
  height: 100%;

  .new-center {
    flex: 5.3;
    background: #f4f4f4;

    .exhibition-wrap {
      background-color: #fff;
      margin-top: 22px;
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .product {
        width: 100%;
        display: flex;

        .product-right {
          width: 30%;
        }
        .product-left {
          width: 70%;
          display: flex;
          flex-wrap: wrap;

          .product-item {
            width: 32%;
            height: 200px;
            display: flex;
            flex-direction: column;
            text-align: left;
            margin-right: 2%;
            margin-bottom: 2%;

            .product-img {
              width: 100%;
              height: 170px;
            }

            .product-title {
              width: 100%;
              height: 30px;
              line-height: 30px;
              text-align: left;
              padding: 0 10px;
              box-sizing: border-box;
            }
          }
          .product-item:hover {
            box-shadow: 5px 5px 5px 2px rgba(0, 0, 0, 0.3);
          }

          .product-item:nth-child(3n) {
            margin-right: 0;
          }
          .product-item:last-child {
            margin-right: auto;
          }
        }
      }

      .exhibition-item {
        width: 32%;
        height: 380px;
        background: #ffffff;
        text-align: left;
        cursor: pointer;
        margin-right: 2%;
        margin-bottom: 2%;

        .exhibition-img {
          width: 100%;
          height: 250px;
        }

        .exhibition-title {
          width: 88%;
          margin-left: 30px;
          font-size: 22px;
          font-weight: bold;
          color: #333333;
          margin-top: 25px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .exhibition-industry {
          margin-left: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #666666;
          margin-top: 10px;
        }

        .exhibition-address {
          width: 88%;
          margin-left: 22px;
          margin-top: 22px;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .exhibition-time {
          margin-left: 22px;
          margin-top: 13px;
          font-size: 16px;
          font-weight: 400;
          color: #999999;
        }
      }

      .exhibition-item:nth-child(3n) {
        margin-right: 0;
      }
      .exhibition-item:last-child {
        margin-right: auto;
      }
    }

    .pagination {
      margin: 4% auto;
    }
  }

  ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #46739f;
    color: #fff;
  }
}

@media only screen and (max-width: 1550px) {
  .new-center {
    flex: 12 !important;
    background: #f4f4f4;
  }
}

.exhibition-table {
  width: 100%;
  background-color: pink;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    background: rgb(239, 239, 239);
  }
  ::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 10px;
  }
}

::v-deep .el-table .cell {
  padding-left: 30px !important;
}
</style>
